<template>
  <div>
    <div v-for="(item, index) in recordList" :key="index">
      <div class="record-box">
        <div class="record-container1">
          <div class="point"></div>
          <div class="operate">
            <!-- {{ item.auditType === 0 ? $t("message.ys") : "" }}
            {{ item.auditType === 1 ? $t("message.zs") : "" }} -->
            {{ item.auditType === 0 || item.auditType === 1 ? $t("message.sh") : "" }}
            {{ item.auditType === 2 ? $t("climant.zrpd") : "" }}
            {{ item.auditType === 3 ? $t("message.zrqr") : "" }}
            {{ item.auditType === 4 ? $t("climant.secondConfirm") : "" }}
            {{ item.auditType === 5 ? $t("seek.submit") : "" }}
            {{ item.auditType === 6 ? $t("message.js") : "" }}
            {{ item.auditType === 7 ? $t("seek.cancel") : "" }}
            {{ item.auditType === 8 ? $t("operate.revocate") : "" }}
            {{ item.auditType === 9 ? $t("climant.secondFill") : "" }}
            {{ item.auditType === 11 ? $t("operate.revocate") : "" }}
            {{ item.auditType === 12 ? $t("operate.preAuthorization") : "" }}
          </div>
        </div>
        <div class="record-container2">
          <div class="line"></div>
          <div class="container">
            <p>
              {{
                item.auditTypeResult.indexOf("审") != -1
                  ? $t("climant.shry")
                  : $t("climant.czry")
              }}：{{ item.staffName }}
            </p>
            <p>
              {{
                item.auditTypeResult.indexOf("审") != -1
                  ? $t("climant.shsj")
                  : $t("climant.czsj")
              }}：{{ item.createTime }}
            </p>
            <p
              v-if="
                !(
                  item.auditTypeResult == '提交' ||
                  item.auditTypeResult == '结算' ||
                  item.auditTypeResult == '取消' ||
                  item.auditTypeResult == '撤回'
                )
              "
            >
              {{
                item.auditTypeResult.indexOf("审") != -1
                  ? $t("climant.shjg")
                  : $t("climant.czjg")
              }}：
              {{ item.status === 1 ? $t("home.passed") : "" }}
              {{ item.status === 2 ? $t("zlfk.bty") : "" }}
              {{ item.status === 3 ? $t("message.bh") : "" }}
              {{ item.status === 4 ? $t("message.jp") : "" }}
              {{ item.status === 5 ? $t("zlfk.clz") : "" }}
              {{ item.status === 6 ? $t("message.yspass") : "" }}
            </p>
            <p v-if="item.remarkzh && item.status != 5">
              {{ $t("zlfk.bhyy") }}：{{ item["remark" + $i18n.locale] }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    recordList: {
      type: Array,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
.record-box {
  // padding-left: 68px;
  .record-container1 {
    display: flex;
    align-items: center;
    .point {
      width: 7px;
      height: 7px;
      border-radius: 7px;
      border: 4px solid #ff0000;
      margin-right: 13px;
    }
    .operate {
      color: #333333;
      font-size: 14px;
      font-weight: bold;
    }
  }
  .record-container2 {
    display: flex;
    height: fit-content;
    margin: 7px 0 12px 0;
    font-size: 14px;
    .line {
      width: 1px;
      border-left: 1px dashed #bbbbbb;
      margin: 0 20px 0 7px;
    }
    .container {
      padding: 10px;
      background-color: #eeeeee;
      width: 446px;
      border-radius: 4px;
      line-height: 35px;
      color: #333333;
    }
  }
}
</style>
